import { useQueryClient } from '@tanstack/react-query';

import { acceptMembershipTermsOfUse } from '../../api/membershipTermsOfUse.api';
import { queryKeys } from '../../queryKeys';
import { useMutation } from '../base';

/** Records acceptance of the membership's current Terms of Use and, if
 * billing had paused for exactly that reason, resumes it. */
export default function useAcceptMembershipTermsOfUse() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acceptMembershipTermsOfUse,
    onSuccess: (_, { clientId, organizationId }) => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.memberships.fetchClientMemberships({
          clientId,
          organizationId,
        }).queryKey,
      });
    },
  });
}
